import React from "react";

import "react-chat-widget/lib/styles.css";

import PropTypes from "prop-types";

export const ChatMessage = ({ message, time }) => {
  return (
    <div className="rcw-client">
      <div className="rcw-message-text">
        <p>{message}</p>
      </div>
      <span className="rcw-timestamp">{time}</span>
    </div>
  );
};
ChatMessage.propTypes = {
  message: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};
